/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IncomingPaymentsEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public incomingPaymentsRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this user.
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/incoming-payments/{id}/',
      path: {
        'id': id,
      },
    });
  }

}
